import type { EnhancedScopeData } from '@ardoq/data-model';
import type { ArdoqId } from '@ardoq/api-types';
import type { Tree, HierarchyEntity } from './types';

const buildHierarchyNode = (
  hierarchyNode: Tree<ArdoqId>,
  scopeData: EnhancedScopeData
): Tree<HierarchyEntity> | null => {
  const component = scopeData.componentsById[hierarchyNode.data];
  if (component) {
    const children = hierarchyNode.children
      .map(childHierarchy => buildHierarchyNode(childHierarchy, scopeData))
      .filter(child => child !== null);

    return {
      data: { type: 'component', data: component },
      children,
    };
  }

  const workspace = scopeData.workspacesById[hierarchyNode.data];
  if (workspace) {
    const children = hierarchyNode.children
      .map(childHierarchy => buildHierarchyNode(childHierarchy, scopeData))
      .filter(child => child !== null) as Tree<HierarchyEntity>[];

    return {
      data: { type: 'workspace', data: workspace },
      children,
    };
  }

  return null;
};

export const buildHierarchyFromScopeData = (
  scopeData: EnhancedScopeData,
  hierarchy: Tree<ArdoqId>[]
): Tree<HierarchyEntity>[] => {
  return hierarchy
    .map(hierarchyNode => buildHierarchyNode(hierarchyNode, scopeData))
    .filter(node => node !== null) as Tree<HierarchyEntity>[];
};
